import * as actionTypes from '../actionTypes';
import { merge, clone, omit } from 'lodash';


// initial state
export const initialState = {};


export default function companyReducer(state = initialState, {type, ...action}) {
  switch (type) {
    case actionTypes.UPDATE_CONTACT_PROFILE : // If UPDATE_CONTACT_PROFILE is dispatch we need to update the company store.
      return merge({}, state, action.contact.company);

    case actionTypes.UPDATE_COMPANY :
      const newState = merge({}, omit(state, ['segmentTypes', 'industryTypes', 'tradeAssociations']), action.company);
      return newState;

    case actionTypes.LOG_OUT :
      return clone(initialState);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./shared/redux/reducers/company.js